<img
  ngSrc="images/landing-splash.webp"
  alt="FirsTech Connect background"
  fill
  priority
/>

<mat-card class="landing-card" [class.visible]="hideBannerWidget">
  <mat-card-header>
    <img
      mat-card-image
      class="logo"
      ngSrc="images/ft-logo-black.svg"
      width="122"
      height="24"
      alt="FirsTech Connect"
    />
  </mat-card-header>
  <mat-card-content>
    <h1 class="welcome-text">
      Welcome to <span class="connect">FirsTech Connect</span>
    </h1>
    <p>
      An intuitive platform, designed to simplify your workflow, drive customer
      satisfaction, and grow your business.
    </p>
  </mat-card-content>
  <mat-card-footer>
    <mat-card-actions>
      <a
        mat-flat-button
        class="login-button"
        href="javascript:void(0);"
        (click)="handleLoginClick($event)"
        (keyup)="handleLoginClick($event)"
        >Get Started!</a
      >
    </mat-card-actions>
  </mat-card-footer>
</mat-card>

<footer>
  <span><a routerLink="/about">About</a></span> |
  <span>Copyright &copy;{{ year }} FirsTech, Inc.</span> |
  <span><a routerLink="/terms">Terms &amp; Conditions</a></span>
</footer>
